export const heights = {
  header: {
    sm: 2.875,
    md: 2.75,
    lg: 2.75,
  },
  mfeHeader: {
    sm: 2.5,
    md: 4,
    lg: 4,
  },
  footer: {
    sm: 45 / 16,
    md: 58 / 16,
    lg: 58 / 16,
  },
};

export const reservedSpace = {
  height: {
    sm: heights.header.sm + heights.mfeHeader.sm + heights.footer.sm,
    md: heights.header.md + heights.mfeHeader.md + heights.footer.md,
    lg: heights.header.lg + heights.mfeHeader.lg + heights.footer.lg,
  },
};

export const reservedSpaceHeader = {
  sm: heights.header.sm + heights.mfeHeader.sm,
  md: heights.header.md + heights.mfeHeader.md,
  lg: heights.header.lg + heights.mfeHeader.lg,
};

export const spaceBetweenSections = 1.875;
export const tocOffset = 0;
export const pixelsPerRem = 16;

export const FIXED_SCROLL_POSITION_OFFSET = 50;
